import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, FormArray, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';

import * as FilePond from 'filepond';
import * as FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import * as FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
// Register plugins
FilePond.registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

import { LoaderService } from '@teem/services/loader.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ProductService } from '@teem/services/product.service';
import { ProductForm } from '@teem/model-forms/product-form';
import { store as StoreApi } from '@teem/constants/api';
import { messages as i18n } from '@teem/constants/messages';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Product } from '@teem/models/product';
import { DEFAULT_LOGO } from '@teem/constants/defaults';
import { ProductAddon } from '@teem/app/core/models/product-addon';
import { ProductAddonForm } from '@teem/app/core/model-forms/product-addon-form';
import { ModifierService } from '@teem/app/core/services/modifier.service';
import { Modifier } from '@teem/app/core/model-forms/modifier-model';
import { AddCategoryModalComponent } from '@teem/app/shared/components/add-category-modal/add-category-modal.component';
import { Select2Directive } from "@teem/directives/select2.directive";
declare var $;

export const minMaxValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const min = group.get('min')?.value;
  const max = group.get('max')?.value;

  if (min != null && max != null && max < min) {
    return { maxLessThanMin: true };
  }

  return null;
};

export function notAllOptionsSelectedValidator(getOptions: () => any[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const selected = control.value || [];
    const allOptions = getOptions() || [];

    if (selected.length == allOptions.length && allOptions.length > 0) {
      return { allOptionsSelected: true };
    }

    return null;
  };
}

@Component({
  selector: 'app-add-products',
  templateUrl: './add-products.component.html',
  styleUrls: ['./add-products.component.scss']
})
export class AddProductsComponent implements OnInit {

  @ViewChild('newProductForm') newProductForm: FormGroupDirective;
  @Input() category: any;
  @ViewChild(Select2Directive) select2Directive = null;
  productForm: FormGroup;
  submitted: boolean = false;
  productCategoriesApi: string = StoreApi.productCategories;
  isSubmitted = false;
  basicInfo: any;
  productImageUrl: any = "";
  base64LogoString = [];
  storeFrontBranchApi: string = StoreApi.branchesInfo;
  selectedStorefrontBranches: Array<any> = [];
  logoFile: any = null;
  logoUrl: any = null;
  defaultLogoUrl: string = DEFAULT_LOGO;
  modifiers: Modifier[] = [];
  modifierOptionsMap: { [key: number]: any[] } = {};
  selectedOptionsLength: number[] = [];
  addNewCategoryTitle: string = i18n.product.add_category; 
  pondOptions = {
    multiple: false,
    // allowRevert: false,
    allowReplace: false,
    allowRemove: true,
    allowImageResize: true,
    allowImagePreview: true,
    imagePreviewMarkupShow:false,
    // labelIdle: `
    // <div style="text-align: center">
    // 	<p>${i18n.drag_and_drop_file}</p>
    // </div>`,
    imageResizeMode: 'cover',
    imageResizeTargetWidth: 170,
    imagePreviewMinHeight: 200,
    imagePreviewHeight: 200,
    imagePreviewMaxHeight: 200,
    imageResizeTargetHeight: 200,
    // server: this.uploadToServer,
    acceptedFileTypes: 'image/png, image/jpeg, image/gif',
    labelIdle: `<span class="icon-upload"></span>`,
    maxFileSize: '500KB',
    beforeRemoveFile: this.pondHandleRemoveFile,
  };

  constructor(
    public activeModal: NgbActiveModal,
    private el: ElementRef,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private productService: ProductService,
    private sharedDataService: SharedDataService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private modifierService: ModifierService,
  ) {
  }

  ngOnInit(): void {
    this.loadCommonData();
    this.basicInfo = (window as any).userInfo;
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.basicInfo = data.userInfo;
      }
    })
    this.productForm = this.fb.group(new ProductForm(new Product()));
    this.loadModifiers();
    setTimeout(() => {
      $('select[nice-select]').val("null").niceSelect('update');
    }, 1000);
  }

  pondHandleInit() {
    // console.log('FilePond has initialised', this.myPond);
  }

  loadModifiers() {
    this.modifierService.getModifiers().subscribe(data => {
      this.modifiers = data;
      setTimeout(() => {
        const addons = this.productForm.get('add_ons') as FormArray;
        let index = 0;
        addons.controls.forEach((addonGroup: AbstractControl) => {
          const modifierId = addonGroup.get('modifier_id')?.value;
          if (modifierId) {
            const selectedModifier = this.modifiers.find(m => m.id == modifierId);
            const modifierOptionIdCtrl = addonGroup.get('modifier_option_id');

            if (selectedModifier) {
              this.modifierOptionsMap[index] = selectedModifier.modifier_options || [];
              const minCtrl = addonGroup.get('min');
              const maxCtrl = addonGroup.get('max');

              minCtrl?.setValidators([
                Validators.required,
                Validators.min(0),
                Validators.max(selectedModifier.maxLimit)
              ]);

              maxCtrl?.setValidators([
                Validators.required,
                Validators.min(0),
                Validators.max(selectedModifier.maxLimit)
              ]);

              modifierOptionIdCtrl?.setValidators([
                notAllOptionsSelectedValidator(() => this.modifierOptionsMap[index])
              ]);
              addonGroup.setValidators(minMaxValidator);
              minCtrl?.updateValueAndValidity();
              maxCtrl?.updateValueAndValidity();
              modifierOptionIdCtrl?.updateValueAndValidity();
            }
            index++;
          }
        })
      }, 1000);
    });
  }

  pondHandleAddFile(event: any) {
    this.base64LogoString = [];

    const file = event.file.file;

    if (file && file?.size <= 512000) {
      const reader = new FileReader();

      reader.onload = this.handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  handleReaderLoaded(e) {
    this.base64LogoString.push('data:image/png;base64,' + btoa(e.target.result));
  }

  async pondHandleRemoveFile(event: any) {
    // let confirm = await Swal.fire({
    //   title: i18n.are_you_sure,
    //   text: i18n.setting.you_want_to_delete_logo,
    //   icon: 'info',
    //   showCloseButton: true,
    //   showCancelButton: true,
    //   focusConfirm: false,
    //   confirmButtonText: i18n.yes,
    //   cancelButtonText: i18n.no_cancel_it
    // })
    // if (confirm.isConfirmed) {
      return true
    // }
    // return false;
  }

  loadCommonData() {
    this.productService.commonData().subscribe((data: any) => {
      this.productForm.get('product_number').setValue(data.next_product_number);
      this.productForm.get('category_id').setValue(this.category.id);
    })
  }

  get f() {
    return this.productForm.controls;
  }

  get amount() {
    let price = this.productForm.controls.price.value;
    let discount = this.productForm.controls.discount_percent.value;

    if (discount)
      return price - (price * discount / 100);

    return price;
  }

  submit() {
    this.isSubmitted = true;
    if (this.productForm.valid) {
      let fd = this.productForm.value;

      if (this.base64LogoString != null) {
        fd.product_image = this.base64LogoString[0];
      }
       
      this.loaderService.startLoading();

      this.productService.create(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe((res) => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.done, i18n.product.added, 'success');
        this.activeModal.close(res);
      }, (err) => {
        this.loaderService.stopLoading();
        if (err.status === 422) {
          if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;
            Object.keys(validationErrors).forEach((prop) => {
              this.productForm.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
      this.isSubmitted = false;
    }
  }

  // Getter for addons FormArray
  get addons(): FormArray {
    return this.productForm.get('add_ons') as FormArray;
  }

  getAddonsFormGroup(index) {
    return this.addons.controls[index] as FormGroup;
  }

  getAvailableModifiers(currentIndex: number): Modifier[] {
    if (!Array.isArray(this.modifiers)) return [];

    const selectedIds = this.addons.controls
      .map((ctrl, idx) => {
        if (idx !== currentIndex) {
          const value = ctrl.get('modifier_id')?.value;
          return this.toSafeNumber(value);
        }
      })
      .filter((id): id is number => id !== null);

    return this.modifiers.filter(mod => !selectedIds.includes(mod.id));
  }

  toSafeNumber(value, fallback = 0) {
    const num = Number(value);
    return isNaN(num) ? fallback : num;
  }

  // Add new addon
  // addAddon() {
  //   const addonGroup = this.fb.group(new ProductAddonForm(new ProductAddon()))
  //   this.addons.push(addonGroup);
  // }
  addAddon() {

    const index = this.addons.length;

    const addonGroup = this.fb.group({
      modifier_id: [null, Validators.required],
      min: [0],
      max: [0],
      modifier_option_id: [[], [
        notAllOptionsSelectedValidator(() => this.modifierOptionsMap[index])
      ]]
    });

    addonGroup.get('modifier_id')?.valueChanges.subscribe((modifierId) => {
      const selectedModifier = this.modifiers.find(m => m.id == modifierId);
      const modifierOptionIdCtrl = addonGroup.get('modifier_option_id');

      if (selectedModifier) {
        this.modifierOptionsMap[index] = selectedModifier.modifier_options || [];

        // Reset modifier_option_id when modifier changes
        addonGroup.get('modifier_option_id')?.setValue([]);

        // Re-apply validators
        addonGroup.get('modifier_option_id')?.updateValueAndValidity();
        
        const minCtrl = addonGroup.get('min');
        const maxCtrl = addonGroup.get('max');

        minCtrl?.setValidators([
          Validators.required,
          Validators.min(0),
          Validators.max(selectedModifier.maxLimit)
        ]);

        maxCtrl?.setValidators([
          Validators.required,
          Validators.min(0),
          Validators.max(selectedModifier.maxLimit)
        ]);

        modifierOptionIdCtrl?.setValidators([
          notAllOptionsSelectedValidator(() => this.modifierOptionsMap[index])
        ]);

        maxCtrl?.setValue(selectedModifier.maxLimit);
        addonGroup.setValidators(minMaxValidator);
        minCtrl?.updateValueAndValidity();
        maxCtrl?.updateValueAndValidity();
        modifierOptionIdCtrl?.updateValueAndValidity();
        // addonGroup.patchValue({ modifier_option_id: [] });
        // this.modifierOptionsMap[index] = selectedModifier.modifier_options || [];
      }
    });

    this.addons.push(addonGroup);
  }

  // minMaxValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  //   const min = group.get('min')?.value;
  //   const max = group.get('max')?.value;

  //   if (min != null && max != null && max < min) {
  //     return { maxLessThanMin: true };
  //   }

  //   return null;
  // };


  // Remove an addon by index
  removeAddon(index: number) {
    this.addons.removeAt(index);
  }

  isNotBranchAndFoodics(){
    return this.basicInfo?.is_branch && !this.basicInfo?.market_place; 
  }

  receiveArray(data: string[], index: number) {
    this.selectedOptionsLength[index] = data.length;
    setTimeout(() => {
      const addons = this.productForm.get('add_ons') as FormArray;
      let index = 0;
      addons.controls.forEach((addonGroup: AbstractControl) => {
        const modifierId = addonGroup.get('modifier_id')?.value;
        if (modifierId) {
          const selectedModifier = this.modifiers.find(m => m.id == modifierId);

          if (selectedModifier) {
            this.modifierOptionsMap[index] = selectedModifier.modifier_options || [];
            const minCtrl = addonGroup.get('min');
            const maxCtrl = addonGroup.get('max');

            minCtrl?.setValidators([
              Validators.required,
              Validators.min(0),
              Validators.max(selectedModifier.maxLimit-this.selectedOptionsLength[index])
            ]);

            maxCtrl?.setValidators([
              Validators.required,
              Validators.min(0),
              Validators.max(selectedModifier.maxLimit-this.selectedOptionsLength[index])
            ]);
            addonGroup.setValidators(minMaxValidator);
            minCtrl?.updateValueAndValidity();
            maxCtrl?.updateValueAndValidity();
          }
          index++;
        }
      })
    }, 200);
  }

  onChangeClient(value: any) {
    console.log(this.category);
    if (value) {
      if (value.id == '__add_new_items__') {
        this.select2Directive.clear();
        const modalRef = this.modalService.open(AddCategoryModalComponent);
        modalRef.componentInstance.type = 'product';
        // Set id on modal dialog
        // modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "newCategory";

        modalRef.result.then(result => {
          this.category = {
            id : result.id,
            name : result.name
          }
          this.productForm.get('category_id').setValue(result.id)
        });
      } else {
        this.category = {
          id : value.id,
          name : value.name
        }
      }
    }
  }
}
